// extracted by mini-css-extract-plugin
module.exports = {"StudiesModuleSubjectForm":"style_StudiesModuleSubjectForm__3sGp4","titleWrapper":"style_titleWrapper__RkHVw","contentWrapper":"style_contentWrapper__1KQ-G"};